export default "__VITE_ASSET__CmFYw2AA__"